import React, { useState, useEffect } from "react";

const CustomerLeftPanel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = ["/login.png", "/login.png", "/login.png"];
  const [imageLoaded, setImageLoaded] = useState(false);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };
  useEffect(() => {
    const interval = setInterval(nextSlide, 3000); // Change slide every 3 seconds
    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);
  const slides = [
    {
      id: 1,
      image: "/technology-hologram-indoor.jpg",
      text1: " Start your",
      text2: "investment journey",
    },
    {
      id: 2,
      image: "/slider-2.png",
      text1: "Unlock your",
      text2: "financial potential",
    },
    {
      id: 3,
      image: "/data-analytics-tablet.jpg",
      text1: "Start small",
      text2: "and dream big",
    },
  ];
  return (
    <div className="relative hidden overflow-hidden lg:flex w-3/5 h-screen">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute w-full bg-black text-white  inset-0 transition-opacity duration-1000 ease-in-out ${
            index === currentIndex
              ? "bg-opacity-70 scale-80"
              : "opacity-0 scale-60"
          }`}
        >
      <div className="relative w-full h-full max-h-[100vh]">
  {/* Shimmer placeholder */}
  {!imageLoaded && (
    <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 z-10" />
  )}

  {/* Image */}
  <img
    src={slide.image}
    alt={slide.text1}
    onLoad={() => setImageLoaded(true)}
    className={`w-full h-full object-cover max-h-[100vh] absolute inset-0 transition-opacity duration-1000 ease-in-out transform
${imageLoaded
  ? currentIndex === 0 || currentIndex === 2
    ? "opacity-90 scale-80"
    : currentIndex === 1
    ? "opacity-100 scale-80"
    : ""
  : "opacity-0 scale-105"}
    `}
    style={{ willChange: "opacity, transform" }}
  />
</div>


          <div className="absolute top-10 left-10">
            <img src="/Caprock-Logo1.svg" alt="Logo" className="h-auto" />
          </div>
<div
  className={`absolute left-10 right-10 md:right-auto bottom-15 text-white transition-all duration-700 ease-in-out ${
    index === currentIndex ? "bottom-20 opacity-100" : "-bottom-20 opacity-0"
  }`}
>
  {/* Background layer behind text — NOT animated */}

  <div className="relative max-w-xl ">
    <h1 className="text-4xl font-light drop-shadow-md">
      {slide.text1}
      <br />
      {slide.text2}
      <br />
      with <span className="italic font-medium">Caprock</span>
    </h1>
    <p className="text-lg font-normal mt-2 drop-shadow">
      Join Caprock today and start investing
      <br />
      with <span className="italic font-medium">0 commission*</span>
    </p>
  </div>
</div>


        </div>
      ))}
      <div className="absolute bottom-12 left-10 flex space-x-2">
        {images.map((image, index) => (
          <div
            key={index}
            className={`h-1 rounded-full transition-all duration-700 ${
              index === currentIndex ? "bg-[#003478] w-10" : "bg-white w-5"
            } cursor-pointer`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
      <div className="absolute bottom-12 right-10 flex items-center space-x-4">
        <button
          className="text-3xl opacity-50  text-gray-400 cursor-pointer hover:opacity-100 transition-all duration-300"
          onClick={prevSlide}
        >
          <img src="/arrow-left-slider.svg" alt="Arrow" className="w-6 h-6" />{" "}
        </button>
        <button
          className="text-2xl opacity-50 text-gray-400 cursor-pointer hover:opacity-100 transition-all duration-300"
          onClick={nextSlide}
        >
          <img src="/arrow-right-slider.svg" alt="Arrow" className="w-6 h-6" />{" "}
        </button>
      </div>
    </div>
  );
};
export default CustomerLeftPanel;
